import type { SearchPropertiesMutationRequest, SearchPropertiesMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { allProperties } from '~/msw/mocks/property'

export function searchPropertiesHandler() {
  return http.post<
    never,
    SearchPropertiesMutationRequest,
    SearchPropertiesMutationResponse
  >('http://localhost:3000/api/v1/properties', async ({ request }) => {
    const body = await request.json()
    return HttpResponse.json(body.reference ? allProperties.filter(annonce => annonce.reference === body.reference) : allProperties)
  })
}
